module.exports = __webpack_public_path__ + "img/folios-icon.ca1ac415.svg";